import FormFilterWrapper from "root/ReactHookForm/ui/FormFilterWrapper";
import DropdownLeas, {DEFAULT_LEA} from "root/s360components/ui/DropdownLeas";
import DropdownLJAppUsageUserType from "root/s360components/LJAppUsage/DropdownLJAppUsageUserType";
import {FormInputCheckbox} from "root/ReactHookForm/FormComponents/FormInputCheckbox";

export const LJAppUsageFormSection = 'filters';

export const LJAppUsageFilterNames = {
    LEA: 'lea',
    USER_TYPE: 'user_type',
    HIDE_UNUSED: 'hide_unused',
}

export const ljAppUsageFilterDefaults = () =>
{
    return {
        [LJAppUsageFormSection]:
            {
                [LJAppUsageFilterNames.LEA]: DEFAULT_LEA,
                [LJAppUsageFilterNames.USER_TYPE]: null,
                [LJAppUsageFilterNames.HIDE_UNUSED]: false,
            }
    }
}

const LJAppUsageFilters = ({control, register, sectionName}) =>
{
    return (
        <FormFilterWrapper>
            <DropdownLeas control={control} name={sectionName + '.' + LJAppUsageFilterNames.LEA}
                          placeholder='Please select an LEA' isSearchable={true} key={'dl'}/>
            <DropdownLJAppUsageUserType control={control} name={sectionName + '.' + LJAppUsageFilterNames.USER_TYPE}
                                        placeholder='Please select a user type' key={'dlut'}/>
            <FormInputCheckbox register={register} sectionName={sectionName} name={LJAppUsageFilterNames.HIDE_UNUSED}
                               label=' Hide schools with no usage' key={'chu'}/>
        </FormFilterWrapper>
    );
}

export default LJAppUsageFilters;
